export default __webpack_public_path__ + "static/1494-2cc77b2302384d0c753db7d3dcc65eb9.gif";